<template>
  <div class="occasion-shop" :class="occasion">
    <div class="header">
        <picture>
          <source media="(max-width: 767px)" :srcset="headers[1] ? headers[1] : headers[0]">
          <img class="main-image" :src="headers[0]"/>
        </picture>
        <img class="main-image" v-if="headers.length > 0" />
        <div class="text-container" :class="occasion">
            <h2>{{occasion}}{{ occasion.includes('Employee') ? ' Day' : '' }} Gifts</h2>
        </div>
        <img v-if="occasion.includes('Employee')" class="spike" src="https://cdn.shopify.com/s/files/1/1363/8433/files/march7.svg?v=1736961201"/>
    </div>
    <div class="top-section">
      <section class="adventure-section">
        <p v-if="waysImages.length == 3" class="main-title">Three ways to shop <br class="mobile"/> for <span>{{ occasion }}{{  occasion.includes('College') ? ' Care Packages' : '' }}</span></p>
        <p v-else class="main-title">Ways to <br class="mobile"/> shop for <span>{{ occasion }}</span></p>
        <Flicking ref="waysFlick" @will-change="change($event)" class="adventures-wrapper mobile" :class="waysImages.length > 3 ? 'small' : ''" :plugins="plugins2" :options="{ align: 'center', circular: true, preventDefaultOnDrag: true,preventClickOnDrag: true, panelsPerView: 1.5 }">
          <div v-if="waysImages.length > 0" @click="selectAdventure(0)" class="adventure" :class="selectedAdventure == 0 ? 'selected' : ''">
            <div class="image-wrapper">
              <img height="200" width="200" :src="waysImages[0]" alt="ready to ship" class="main-image"/>
            </div>
            <div class="text-wrapper">
              <p class="title">Curated Gift Sets</p>
              <p v-if="waysImages.length > 3" class="subtitle">Unwrap joy with our expertly <br class="mobile"/> curated holiday gifts!</p>
              <p v-else class="subtitle">Expertly curated trending gifts, ready to send</p>
              <a :href="'/pages/ready-to-ship?occasion=' + occasion" class="happybox-button white border desktop">Shop</a>
              <a :href="'/pages/ready-to-ship?occasion=' + occasion" class="legend mobile">Shop ></a>
            </div>
          </div>
          <div v-if="waysImages.length > 1" @click="selectAdventure(1)" class="adventure" :class="selectedAdventure == 1 ? 'selected' : ''">
            <div class="image-wrapper">
              <img height="200" width="200" :src="waysImages[1]" alt="build a box" class="main-image"/>
            </div>
            <div class="text-wrapper">
              <p class="title">Build a Gift Box</p>
              <p v-if="waysImages.length > 3" class="subtitle">Build a custom holiday gift box with all of their favorite things!</p>
              <p v-else class="subtitle">Pick from hundreds of items to build a gift that’s uniquely theirs</p>
              <a :href="'/products/build-a-box?occasion=' + occasion" class="happybox-button white border desktop">Start Building</a>
              <a :href="'/products/build-a-box?occasion=' + occasion" class="legend mobile">Start Building ></a>
            </div>
          </div>
          <div v-if="waysImages.length > 2" @click="selectAdventure(2)" class="adventure" :class="selectedAdventure == 2 ? 'selected' : ''">
            <div class="image-wrapper">
              <img height="200" width="200" :src="waysImages[2]" alt="gift of choice" class="main-image goc" :class="occasion"/>
            </div>
            <div class="text-wrapper">
              <p class="title">Gift of Choice</p>
              <p v-if="waysImages.length > 3" class="subtitle">Let them choose their own gift from our festive holiday collection!</p>
              <p v-else class="subtitle">You pick your budget, they pick their gift</p>
              <a :href="'/pages/gift-of-choice?occasion=' + occasion" class="happybox-button white border desktop">Get Started</a>
              <a :href="'/pages/gift-of-choice?occasion=' + occasion" class="legend mobile">Get Started ></a>
            </div>
          </div>
          <div v-if="waysImages.length > 3" @click="selectAdventure(3)" class="adventure" :class="selectedAdventure == 3 ? 'selected' : ''">
            <div  class="image-wrapper">
              <img height="200" width="200" :src="waysImages[3]" alt="gift of choice" class="main-image bulk" :class="occasion"/>
            </div>
            <div class="text-wrapper">
              <p class="title">Bulk Custom Gifting</p>
              <p class="subtitle">Out experts will design & ship 100% custom gifts & packaging with your branding</p>
              <a href="/pages/submit-an-inquiry-concierge-gifting" class="happybox-button white border desktop">Request a Custom Proposal</a>
              <a href="/pages/submit-an-inquiry-concierge-gifting" class="legend mobile">Request a Custom Proposal ></a>
            </div>
          </div>
        </Flicking>
        <div id="aWrap" class="adventures-wrapper desktop" :class="waysImages.length > 3 ? 'small' : ''">
          <div v-if="waysImages.length > 0" @click="selectAdventure(0)" class="adventure" :class="selectedAdventure == 0 ? 'selected' : ''">
            <div  class="image-wrapper">
              <img height="200" width="200" :src="waysImages[0]" alt="ready to ship" class="main-image"/>
            </div>
            <div class="text-wrapper">
              <p class="title">Curated Gift Sets</p>
              <p v-if="waysImages.length > 3" class="subtitle">Unwrap joy with our expertly curated holiday gifts!</p>
              <p v-else class="subtitle">Expertly curated trending gifts, ready to send</p>
              <a :href="'/pages/ready-to-ship?occasion=' + occasion" class="happybox-button white border desktop">Shop</a>
              <a :href="'/pages/ready-to-ship?occasion=' + occasion" class="legend mobile">Shop ></a>
            </div>
          </div>
          <div v-if="waysImages.length > 1" @click="selectAdventure(1)" class="adventure" :class="selectedAdventure == 1 ? 'selected' : ''">
            <div  class="image-wrapper">
              <img height="200" width="200" :src="waysImages[1]" alt="build a box" class="main-image"/>
            </div>
            <div class="text-wrapper">
              <p class="title">Build a Gift Box</p>
              <p v-if="waysImages.length > 3" class="subtitle">Build a custom holiday gift box with all of their favorite things!</p>
              <p v-else class="subtitle">Pick from hundreds of items to build a gift that’s uniquely theirs</p>
              <a :href="'/products/build-a-box?occasion=' + occasion" class="happybox-button white border desktop">Start Building</a>
              <a :href="'/products/build-a-box?occasion=' + occasion" class="legend mobile">Start Building ></a>
            </div>
          </div>
          <div v-if="waysImages.length > 2" @click="selectAdventure(2)" class="adventure" :class="selectedAdventure == 2 ? 'selected' : ''">
            <div class="image-wrapper">
              <img height="200" width="200" :src="waysImages[2]" alt="gift of choice" class="main-image goc" :class="occasion"/>
            </div>
            <div class="text-wrapper">
              <p class="title">Gift of Choice</p>
              <p v-if="waysImages.length > 3" class="subtitle">Let them choose their own gift from our festive holiday collection!</p>
              <p v-else class="subtitle">You pick your budget, they pick their gift</p>
              <a :href="'/pages/gift-of-choice?occasion=' + occasion" class="happybox-button white border desktop">Get Started</a>
              <a :href="'/pages/gift-of-choice?occasion=' + occasion" class="legend mobile">Get Started ></a>
            </div>
          </div>
          <div v-if="waysImages.length > 3" @click="selectAdventure(3)" class="adventure" :class="selectedAdventure == 3 ? 'selected' : ''">
            <div  class="image-wrapper">
              <img height="200" width="200" :src="waysImages[3]" alt="gift of choice" class="main-image bulk" :class="occasion"/>
            </div>
            <div class="text-wrapper">
              <p class="title">Bulk Custom Gifting</p>
              <p class="subtitle">Out experts will design & ship 100% custom gifts & packaging with your branding</p>
              <a href="/pages/submit-an-inquiry-concierge-gifting" class="happybox-button white border desktop">Request a Custom Proposal</a>
              <a href="/pages/submit-an-inquiry-concierge-gifting" class="legend mobile">Request a Custom Proposal ></a>
            </div>
          </div>
        </div>
      </section>
      <section class="rts-section">
        <div class="normal-container">
          <div class="title-header">
            <p class="title-container">
              <span class="title">Curated Gift Sets</span>
              <span class="subtitle">Expertly curated gifts, each with a handwritten note</span>
            </p>
            <div class="arrows-container">
              <img @click="$refs.rts.prev();" class="l-arrow" src="https://cdn.shopify.com/s/files/1/1363/8433/files/white_button_square.svg?v=1720472546" alt="left arrow"/>
              <img @click="$refs.rts.next();" class="r-arrow" src="https://cdn.shopify.com/s/files/1/1363/8433/files/white_button_square.svg?v=1720472546" alt="right arrow"/>
            </div>
          </div>
          <div class="collections-container" v-if="rtsProducts.length == 0">
            <SkeletonPlaceholder v-for="n in skeletons" :key="n" />
          </div>
          <div v-else class="collections-container">
            <Flicking ref="rts" class="flicking-goc-collection" :plugins="plugins1" :options="{ align: 'prev', circular: true, preventDefaultOnDrag: true,preventClickOnDrag: true, panelsPerView: panels }">
              <a class="ready-product" target="_blank" :href="'https://happyboxstore.com/products/' + product.handle" v-for="product in rtsProducts" :key="product.id">
                <img loading="lazy" :src="product | getProductImage" :alt="product.title"/>
                <button class="happybox-button white border">{{ product.title }}</button>
              </a>
            </Flicking>
          </div>
          <a :href="'/pages/ready-to-ship?occasion=' + occasion" class="happybox-button white border">Shop All</a>
        </div>
      </section>
      <section class="builder-section">
        <div class="normal-container">
          <div class="title-header">
            <p class="title-container">
              <span class="title">Build a Gift Box</span>
              <span class="subtitle">Themed gift items to create custom gift from scratch</span>
            </p>
          </div>
          <div class="collections-container" v-if="filteredAddons.length == 0">
            <SkeletonPlaceholder v-for="n in builderSkeletons" :key="n" />
          </div>
          <div v-else class="collections-container wrap">
            <AddonProduct :occasion="occasion" :product="product" v-for="product in filteredAddons" :key="product.id"/>
          </div>
          <a :href="'/products/build-a-box?occasion=' + occasion" class="happybox-button white border">Build a Gift Box</a>
        </div>
      </section>
      <section v-if="gocImage && gocImage.length > 0" class="goc-section">
        <div class="normal-container">
          <div class="title-header">
            <p class="title-container">
              <span class="title">Gift of Choice</span>
              <span class="subtitle">We've curated the perfect collection of gifts for them to choose from</span>
            </p>
          </div>
          <picture @click="goToGOC">
            <source media="(max-width: 767px)" :srcset="gocImage[1] ? gocImage[1] : gocImage[0]">
            <img class="goc-image" :src="gocImage[0]" />
          </picture>
          <a :href="'/pages/gift-of-choice?occasion=' + occasion" class="happybox-button white border mobile">Get Started</a>
        </div>
      </section>
      <section>
        <Carousel v-if="!slides || slides.length == 0"/>
        <ContentCarousel v-else :slides="slides"/>
      </section>
      <section class="looking-for">
        <p>Looking for custom <br class="mobile"/> {{ occasion }} gifts for <br class="mobile"/> your company? <br class="mobile"/> We do that too.</p>
        <a target="_blank" href="https://calendar.app.google/BS3epNk6LrNPc7ca6" class="happybox-button green border">Book a Call</a>
      </section>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SkeletonPlaceholder from './components/Skeletons/AddonProductSkeleton.vue'
import AddonProduct from './components/AddonProduct.vue';
import Carousel from './components/Snippets/Carousel.vue';
import ContentCarousel from './components/Snippets/ContentCarousel.vue';
import { AutoPlay } from "@egjs/flicking-plugins";
require('dotenv').config();

export default {
  components:{
    SkeletonPlaceholder,
    AddonProduct,
    Carousel,
    ContentCarousel
  },
  data(){
    return{
      plugins1: [new AutoPlay({ duration: 3000, direction: "NEXT", stopOnHover: false })],
      plugins2: [new AutoPlay({ duration: 3000, direction: "NEXT", stopOnHover: false })],
      selectedAdventure: 0,
    }
  },
  computed:{
    ...mapGetters([
      'occasion',
      'rtsProducts',
      'addonProducts',
      'gocImage',
      'waysImages',
      'headers',
      'slides',
    ]),
    filteredAddons(){
      if(this.isMobile)
        return this.addonProducts.slice(0,6);

      return this.addonProducts.slice(0,8);
    },
    isMobile() {
      return window.innerWidth < 768;
    },
    panels(){
      if(this.isMobile){
        return 1.5
      }
      else {
        return 4
      }
    },
    skeletons(){
      if(this.isMobile){
        return 1
      }
      else {
        return 4
      }
    },
    builderSkeletons(){
      if(this.isMobile){
        return 2
      }
      else {
        return 4
      }
    },
  },
  methods:{
    selectAdventure(index){
      this.$refs.waysFlick.moveTo(index)
    },
    change(event){
      this.selectedAdventure = event.index;
    },
    goToGOC(){
      if(window.innerWidth > 767){
        location.href = `/pages/gift-of-choice?occasion=${this.occasion}`
      }
    },
  },
  mounted() {
  },
  destroy() {
  }
}
</script>
<style>
  .flicking-goc-collection {
    min-width: 100%;
  }
  .flicking-goc-collection .flicking-camera{
    padding: 1% 0%;
  }

  .occasion-shop{
    width: 100%;
    background-image: linear-gradient(#F9FBFD, #EBFEFA, #E0E7FF);
    display: flex;
    flex-direction: column;
  }

  .occasion-shop.Galentine\'s{
    background-image: linear-gradient(#FDFCF9, #FFF5F9, #FFE0E0);
  }

  .occasion-shop p,.occasion-shop span{
    color: #0f0c38;
  }
</style>
<style scoped>
.header{
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
}

.header .main-image{
  width: 100%;
}

.header picture{
  display: flex;
}

.header .text-container{
    position: absolute;
    width: 50%;
    right: 0%;
    top: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.header .spike{
  position: absolute;
  width: 10%;
  bottom: 3%;
  left: 55%;
}

.header .text-container.Thank,.header .text-container.Wellness,.header .text-container.Celebration{
  width: 60%;
}

.header .text-container.Galentine\'s{
  left: 15%;
  width: 30%;
  bottom: 15%;
}

.header .text-container.Employee{
  right: 15%;
  width: 40%;
}

.header .text-container.Feel{
  width: 55%;
}

.header .text-container.Bereavement{
  width: 70%;
}


.header .text-container.Holiday h2{
  color: white;
}

.header .text-container h2{
    font-size: 6vw;
    line-height: .8;
    font-family: Founders Grotesk, sans-serif;
    font-weight: 600;
    margin: unset;
    margin-bottom: 1rem;
    width: auto;
    text-align: left;
}

.top-section{
		padding: 2% 15% 0;
    position: relative;
	}

.adventure-section{
    width: 100%;
    margin-bottom: 12%;
  }

  .adventure-section .main-title{
    text-align: center;
    color: #0f0c38;
    font-family: "ff-more-web-pro-condensed", "Karla", sans-serif;
    font-weight: 300;
    font-size: 3.5vw;
    margin: 0.5rem 0 2rem;
  }

  .adventure-section .main-title span{
    font-style: italic;
    font-family: "ff-more-web-pro-condensed", "Karla", sans-serif;
    font-weight: 300;
  }

  .adventure-section .adventures-wrapper{
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 2%;
  }

  .adventure-section .adventures-wrapper .adventure{
    width: 32%;
    display: flex;
    flex-direction: column;
    transition: all 1s ease;
  }
  

  .adventure-section .adventures-wrapper .adventure .image-wrapper,.adventure-section .adventures-wrapper .adventure .text-wrapper{
    background-color: #fcfaf4;
  }

  .adventure-section .adventures-wrapper .adventure:hover .image-wrapper,.adventure-section .adventures-wrapper .adventure:hover .text-wrapper{
    background-color: #FFF4E2;
  }

  .adventure-section .adventures-wrapper .adventure .image-wrapper{
    width: 100%;
    border-top-left-radius: 50%;
    border-top-right-radius: 50%;
    padding: 0.5rem 0.5rem 0;
    border-left: 1px solid lightgray;
    border-top: 1px solid lightgray;
    border-right: 1px solid lightgray;
    position: relative;
    aspect-ratio: 1;
  }

  .adventure-section .adventures-wrapper .adventure .image-wrapper img{
    width: 100%;
    height: auto;
  }

  .adventure-section .adventures-wrapper .adventure .image-wrapper .goc{
    position: absolute;
    top: -9%;
    left: 0%;
    width: 105%;
    height: auto;
  }

  .adventure-section .adventures-wrapper .adventure .image-wrapper .goc.Birthday{
    left: -5%;
  }

  .adventure-section .adventures-wrapper .adventure .image-wrapper .goc.College{
    top: 0%;
  }

  .adventure-section .adventures-wrapper .adventure .image-wrapper .goc.Thank{
    width: 100%;
    top: -3%;
    padding: 5%;
  }

  .adventure-section .adventures-wrapper .adventure .image-wrapper .goc.Holiday{
    top: 3%;
  }

  .adventure-section .adventures-wrapper .adventure .image-wrapper .goc.Wellness,.adventure-section .adventures-wrapper .adventure .image-wrapper .goc.Feel{
    position: absolute;
    top: 4%;
    left: 6%;
    width: 100%;
    height: auto;
  }

  .adventure-section .adventures-wrapper .adventure .image-wrapper .goc.Celebration{
    position: absolute;
    top: 4%;
    left: -4%;
    width: 100%;
    height: auto;
  }

  .adventure-section .adventures-wrapper .adventure .image-wrapper .goc.Galentine\'s,
  .adventure-section .adventures-wrapper .adventure .image-wrapper .goc.Employee{
    position: static;
    width: 100%;
  }

  .adventure-section .adventures-wrapper .adventure .image-wrapper .goc.Father\'s{
    top: 0%;
    left: 4%;
  }

  .adventure-section .adventures-wrapper .adventure .image-wrapper .goc.Graduation{
    top: 2%;
    left: -2%;
  }

  .adventure-section .adventures-wrapper .adventure .text-wrapper{
    flex-direction: column;
    display: flex;
    padding: 0 1rem 1rem;
    border-left: 1px solid lightgray;
    border-bottom: 1px solid lightgray;
    border-right: 1px solid lightgray;
    min-height: 12vw;
    justify-content: space-between;
  }

  .adventure-section .adventures-wrapper .adventure .text-wrapper .title{
    font-size: 1.5vw;
    text-align: center;
    font-weight: bold;
    border-bottom: 1px solid lightgray;
    padding-bottom: 0.3rem;
  }

  .adventure-section .adventures-wrapper .adventure .text-wrapper .subtitle{
    font-size: 1vw;
    text-align: center;
    line-height: 1.2;
  }

  .normal-container{
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 0% 0 10% 0%;
    align-items: center;
    position: relative;
  }
  .normal-container > .happybox-button{
    padding: 1% 10%;
    margin-top: 1rem;
  }

  .normal-container .title-header{
    width: 100%;
    display: flex;
    padding-bottom: 2%;
    border-bottom: 1px solid lightgray;
    align-items: flex-end;
    justify-content: space-between;
    margin-bottom: 1rem;
  }

  .normal-container .title-header .title-container{
    max-width: 80%;
    border-bottom: unset;
    padding-bottom: unset;
    margin: unset;
    flex-direction: column;
    align-items: flex-start;
  }

  .normal-container .title-header .arrows-container{
    display: flex;
    align-items: center;
    gap: 5%;
    min-width: 20%;
    justify-content: center;
  }

  .normal-container .title-header .arrows-container img{
    cursor: pointer;
    height: 3vw;
  }

  .normal-container .title-header .arrows-container .r-arrow{
    transform: rotate(180deg);
  }

  .normal-container .title-container{
    width: 100%;
    display: flex;
    padding-bottom: 2%;
    border-bottom: 1px solid lightgray;
    align-items: center;
    gap: 2%;
  }

  .normal-container .title-container .title{
    font-size: 1.5vw;
    line-height: 1;
    font-family: Karla, sans-serif;
    font-weight: bold;
    margin-bottom: 0.5rem;
  }

  .normal-container .title-container .subtitle{
    font-size: 1.15vw;
    line-height: 1;
  }

  .normal-container .title-container .legend{
    font-size: 1.15vw;
    line-height: 1;
    font-style: italic;
  }

  .collections-container{
    width: 100%;
    display: flex;
    gap: 2%;
  }
  
  .collections-container.wrap{
    flex-wrap: wrap;
    gap: 1.3%;
  }

  .ready-product{
    background-color: #fff;
    border: 1px solid lightgray;
    padding: 0.5rem;
    position: relative;
    margin-right: 1rem;
  }

  .ready-product img{
    width: 100%;
    aspect-ratio: 1;
    object-fit: contain;
  }

  .ready-product > .happybox-button{
    width: 90%;
    margin-left: 5%;
    font-size: 0.8vw;
  }

  .looking-for{
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 7%;
  }

  .looking-for p{
    font-size: 3.5vw;
    line-height: .8;
    font-family: Founders Grotesk, sans-serif;
    font-weight: 600;
    margin: unset;
    width: 70%;
  }

  .looking-for .happybox-button{
    flex: 1;
    padding: 1%;
  }

  .goc-image{
    width: 100%;
    cursor: pointer;
  }

  .occasion-shop .breadcrumb{
    position: absolute;
    margin: unset;
    top: 1rem;
    left: 10%;
    color: #7e7ea5;
  }

  .breadcrumb a{
    text-decoration: underline;
    color: #7e7ea5;
  }

  @media screen and (min-width: 768px) {
    .adventure-section .adventures-wrapper.small .adventure{
      width: 24%;
    }

    .adventure-section .adventures-wrapper.small .adventure .happybox-button{
      font-size: 0.8vw;
    }

    .adventure-section .adventures-wrapper.small .adventure .text-wrapper .subtitle{
      font-size: 0.9vw;
    }

    .adventure-section .adventures-wrapper.small  .adventure .text-wrapper .title{
      font-size: 1.3vw;
    }

    .header .text-container.Mother\'s{
      right: 5%;
    }

    .header .text-container.Graduation{
  right: 25%;
}

.header .text-container.Graduation h2{
  text-align: center;
}

  }
@media screen and (max-width: 767px) {

  .top-section{
		padding: 2% 5% 0;
    overflow: hidden;
	}

  .normal-container .title-container .title{
    font-family: Karla, sans-serif;
    font-weight: 700;
    font-size: 4vw;
    margin-bottom: .5rem;
  }

  .normal-container .title-container .subtitle
  ,.normal-container .title-container .legend{
    font-size: 3.5vw;
    line-height: 1.2;
  }

  .normal-container .title-header .arrows-container img{
    height: 5vh;
  }

  .collections-container,.collections-container.wrap{
    width: 100%;
    margin: unset;
    gap: 4%;
  }

  .addon-product-container{
    width: 48%;
  }

  .ready-product>.happybox-button{
    font-size: 3vw;
  }

  .header .text-container{
    right: 1%;
  }

  .header .text-container.Holiday{
    width: 55%;
  }

  .header .text-container h2{
    font-size: 12vw;
    width: 100%;
    margin-bottom: 2rem;
  }

  .adventure-section .main-title{
    font-size: 7vw;
    margin-bottom: 1rem;
    line-height: 1.2;
    margin-top: 1rem;
  }

  .occasion-shop .breadcrumb{
    display: none;
  }

  .adventure-section .adventures-wrapper .adventure .text-wrapper .title{
    font-size: 3.5vw;
  }

  .adventure-section .adventures-wrapper .adventure .text-wrapper .subtitle{
    font-size: 3vw;
  }

  .adventure-section .adventures-wrapper{
    width: 100vw;
    margin-left: -5vw;
    transition: all 1s ease;
    padding: 5% 0;
  }

  .adventure-section .adventures-wrapper .adventure{
    margin-right: 2%;
  }

  .looking-for{
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }

  .looking-for p{
    font-size: 10vw;
    width: 100%;
    text-align: center;
  }

  .looking-for .happybox-button{
    padding: 2% 10%;
  }
  .text-wrapper .legend{
    font-size: 2.5vw;
    color: #A01ADB;
    text-align: center;
    margin: unset;
    font-weight: bold;
  }

  .adventure-section .adventures-wrapper .adventure .image-wrapper
  ,.adventure-section .adventures-wrapper .adventure .text-wrapper{
    background-color: #fcfaf4 !important;
  }

  .adventure-section .adventures-wrapper .adventure.selected .image-wrapper
  ,.adventure-section .adventures-wrapper .adventure.selected .text-wrapper{
    background-color: #FFF4E2 !important;
  }

  .adventure-section .adventures-wrapper .adventure.selected{
    top: -1rem;
    position: relative;
  }

  .adventure-section .adventures-wrapper .adventure .text-wrapper{
    min-height: 33vw;
  }

  .goc-section .normal-container>.happybox-button{
    margin: unset;
    position: absolute;
    bottom: 28%;
    right: 15%;
    width: 50%;
  }

  .header .text-container.Galentine\'s{
    bottom: 0;
    left: 5%;
    width: 50%;
  }

  .header .text-container.Employee{
    right: 7%;
  }

  .header .text-container.Employee h2{
    font-size: 10vw;
  }

  .header .spike{
    width: 22%;
    bottom: -22%;
    left: 7%;
  }

  .header .text-container.Thank{
    width: 50%;
  }
  
}
</style>